export function getStringLength(string: string): number {
  // Use Array.from to correctly count Unicode characters
  return Array.from(string).length;
}
